import { ToastOptions } from 'react-toastify';

export const toastifyConfig: ToastOptions = {
	position: 'top-right',
	autoClose: 3000,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
	style: {
		maxHeight: 'none',
		height: 'auto',
		width: '320px',
		maxWidth: '90vw',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		overflow: 'visible',
		wordWrap: 'break-word',
		overflowWrap: 'break-word',
	},
};
